import { Component, inject } from '@angular/core';
import {CookieService} from "ngx-cookie-service";
import {NavigationService} from "planner-shared";

@Component({
    templateUrl: './page-not-found.component.html',
    standalone: false
})
export class PageNotFoundComponent {
    private readonly cookieService = inject(CookieService);
    private readonly navigationService = inject(NavigationService);


    public retry(): void {
        const previousPage = this.cookieService.get("previous-page");
        this.navigationService.navigate(Number(previousPage));
    }

    public returnToStepOne(): void {
        this.navigationService.navigateToStep1();
    }
}
